"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createParam;

// Copyright 2017-2019 @polkadot/jsonrpc authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
function createParam(name, type) {
  let {
    isOptional = false
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    isOptional: false
  };
  return {
    isOptional,
    name,
    type
  };
}